export function getNewName(names: Array<string>, actualName: string): string {
    let nameToReturn = actualName;

    let numbers = names?.map((oneName: string) => {
        let regex = new RegExp(`^${actualName}(\\s*\\d+)*$`, 'gi');
        let regexOutput = regex.exec(oneName);
        if (regexOutput && regexOutput[0] === oneName && regexOutput[1]) {
            try {
                let num = Number.parseInt(regexOutput[1].trim());
                return num;
            } catch (e) {
                console.error(e);
                return undefined;
            }
        } else
            return undefined;
    }).filter(ob => ob !== undefined);

    if (numbers?.length === 0 && names?.includes(actualName)) {
        nameToReturn = actualName + ' ' + 1;
    } else if (numbers?.length > 0 && names?.includes(actualName)) {
        for (let i = 1; i < 20; i++) {
            if (!numbers.includes(i)) {
                nameToReturn = actualName + ' ' + i;
                break;
            }
        }
    }
    return nameToReturn;
}

export function scrollToTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}